<script lang="ts" setup>
const error: any = useError()
const { $t } = useNuxtApp()
const config = useRuntimeConfig()

useHead({
    title: $t('Chyba'),
    titleTemplate: `%s | ${config.public.seo.title}`,
    link: [...useFavicons()],
})
</script>
<template>
  <Header />
  <ContainerFluid>
    <Error404Error404 v-if="error?.statusCode == 404" />
    <template v-else>
      <ErrorGeneric />
    </template>
  </ContainerFluid>
  <Footer />
  <div id="modal-wrap" />
</template>
